import { TProps } from './types/TProps';

export const ParamRow = ({ name, type, required = false, description }: TProps) => (
  <tr className="border-b border-[var(--color-border)] align-top last:border-b-0">
    <td className="py-2 pr-4">
      <code className="font-mono text-xs font-semibold text-[var(--color-text)]">{name}</code>
      {required ? <span className="ml-2 text-xs font-semibold text-[var(--color-danger)]">required</span> : null}
    </td>
    <td className="py-2 pr-4 font-mono text-xs text-[var(--color-text-subtle)]">{type}</td>
    <td className="py-2 text-[var(--color-text)]">{description}</td>
  </tr>
);
